const timezones = [
  {
    'GMT-11:00': ['Pacific/Midway', 'Pacific/Niue', 'Pacific/Pago_Pago'],
  },
  {
    'GMT-10:00': [
      'Pacific/Honolulu',
      'Pacific/Johnston',
      'Pacific/Rarotonga',
      'Pacific/Tahiti',
    ],
  },
  {
    'GMT-09:30': ['Pacific/Marquesas'],
  },
  {
    'GMT-09:00': ['America/Adak', 'Pacific/Gambier'],
  },
];

export default timezones;
